import { useState, useEffect } from "react";

const BASE = "https://support.gs-group.fr/api";
const hdr = () => ({ "Content-Type":"application/json", Authorization:"Bearer "+localStorage.getItem("nexo_token") });

export default function StockVehicule({ T, vehiculeId, vehiculeLabel="" }) {
  const [items,    setItems]    = useState([]);
  const [produits, setProduits] = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [adding,   setAdding]   = useState(false);
  const [form,     setForm]     = useState({ produit_id:"", quantite:1 });
  const [saving,   setSaving]   = useState(false);
  const [search,   setSearch]   = useState("");

  useEffect(()=>{ if(vehiculeId) load(); },[vehiculeId]);

  const load = async () => {
    setLoading(true);
    const [sv, pr] = await Promise.all([
      fetch(`${BASE}/vehicules/${vehiculeId}/stock`,{headers:hdr()}).then(r=>r.json()).catch(()=>[]),
      fetch(`${BASE}/stock`,{headers:hdr()}).then(r=>r.json()).catch(()=>[]),
    ]);
    setItems(Array.isArray(sv)?sv:[]);
    setProduits(Array.isArray(pr)?pr:[]);
    setLoading(false);
  };

  const save = async () => {
    if(!form.produit_id) return;
    setSaving(true);
    await fetch(`${BASE}/vehicules/${vehiculeId}/stock`,{
      method:"POST", headers:hdr(),
      body:JSON.stringify({ produit_id:Number(form.produit_id), quantite:Number(form.quantite)||0 }),
    });
    setAdding(false); setForm({produit_id:"",quantite:1});
    await load();
    setSaving(false);
  };

  const updateQty = async (item, delta) => {
    const newQty = Math.max(0, item.quantite + delta);
    await fetch(`${BASE}/vehicules/${vehiculeId}/stock`,{
      method:"POST", headers:hdr(),
      body:JSON.stringify({ produit_id:item.produit_id, quantite:newQty }),
    });
    setItems(p=>p.map(i=>i.produit_id===item.produit_id?{...i,quantite:newQty}:i));
  };

  const remove = async (item) => {
    await fetch(`${BASE}/vehicules/${vehiculeId}/stock/${item.produit_id}`,{method:"DELETE",headers:hdr()});
    setItems(p=>p.filter(i=>i.produit_id!==item.produit_id));
  };

  const existing = new Set(items.map(i=>i.produit_id));
  const available = produits.filter(p=>!existing.has(p.id)&&(
    !search || p.designation.toLowerCase().includes(search.toLowerCase()) ||
    (p.reference||"").toLowerCase().includes(search.toLowerCase())
  ));

  if(loading) return <div style={{textAlign:"center",padding:20,color:T.muted,fontSize:13}}>⏳ Chargement…</div>;

  return (
    <div style={{display:"flex",flexDirection:"column",gap:12}}>

      {/* En-tête */}
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
        <div>
          <div style={{fontSize:14,fontWeight:800,color:T.text}}>📦 Stock tampon</div>
          <div style={{fontSize:11,color:T.muted}}>{items.length} référence{items.length!==1?"s":""} · {vehiculeLabel}</div>
        </div>
        <button onClick={()=>setAdding(a=>!a)}
          style={{padding:"7px 14px",borderRadius:9,background:T.accentDim,border:`1px solid ${T.accent}`,color:T.accent,fontSize:12,fontWeight:700,cursor:"pointer"}}>
          {adding?"Annuler":"＋ Ajouter"}
        </button>
      </div>

      {/* Formulaire ajout */}
      {adding&&(
        <div style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:11,padding:14,display:"flex",flexDirection:"column",gap:10}}>
          <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Rechercher un produit…"
            style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:8,padding:"8px 12px",color:T.text,fontSize:13,outline:"none"}}/>
          <select value={form.produit_id} onChange={e=>setForm(p=>({...p,produit_id:e.target.value}))}
            style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:8,padding:"8px 12px",color:T.text,fontSize:13,outline:"none",cursor:"pointer"}}>
            <option value="">— Sélectionner un produit —</option>
            {available.map(p=>(
              <option key={p.id} value={p.id}>{p.designation}{p.reference?` (${p.reference})`:""}</option>
            ))}
          </select>
          <div style={{display:"flex",alignItems:"center",gap:10}}>
            <label style={{fontSize:12,color:T.muted,fontWeight:600}}>Quantité :</label>
            <input type="number" min="0" value={form.quantite} onChange={e=>setForm(p=>({...p,quantite:e.target.value}))}
              style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:8,padding:"8px 12px",color:T.text,fontSize:13,outline:"none",width:80}}/>
            <button onClick={save} disabled={saving||!form.produit_id}
              style={{flex:1,padding:"8px",borderRadius:8,background:T.accent,border:"none",color:"#fff",fontSize:12,fontWeight:700,cursor:"pointer",opacity:!form.produit_id?0.5:1}}>
              {saving?"Ajout…":"✓ Ajouter"}
            </button>
          </div>
        </div>
      )}

      {/* Liste items */}
      {items.length===0&&!adding&&(
        <div style={{textAlign:"center",padding:"20px",color:T.muted,background:T.bg,borderRadius:11,border:`1px dashed ${T.border}`}}>
          <div style={{fontSize:28,marginBottom:6}}>📦</div>
          <div style={{fontSize:13}}>Aucun stock tampon enregistré</div>
        </div>
      )}

      {items.map(item=>{
        const niveau = item.quantite===0?"critique":item.quantite<=2?"faible":"ok";
        const col = niveau==="critique"?"#ef4444":niveau==="faible"?"#f59e0b":T.success;
        return (
          <div key={item.produit_id} style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:10,padding:"10px 14px",display:"flex",alignItems:"center",gap:12}}>
            <div style={{width:8,height:8,borderRadius:"50%",background:col,flexShrink:0}}/>
            <div style={{flex:1,minWidth:0}}>
              <div style={{fontSize:13,fontWeight:600,color:T.text,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{item.designation}</div>
              <div style={{fontSize:11,color:T.muted}}>{item.reference&&`Réf. ${item.reference} · `}{item.categorie}</div>
            </div>
            {/* Compteur quantité */}
            <div style={{display:"flex",alignItems:"center",gap:6,flexShrink:0}}>
              <button onClick={()=>updateQty(item,-1)} style={{width:24,height:24,borderRadius:6,border:`1px solid ${T.border}`,background:"transparent",color:T.text,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",fontSize:14}}>−</button>
              <span style={{fontSize:14,fontWeight:800,color:col,minWidth:24,textAlign:"center"}}>{item.quantite}</span>
              <button onClick={()=>updateQty(item,+1)} style={{width:24,height:24,borderRadius:6,border:`1px solid ${T.border}`,background:"transparent",color:T.text,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",fontSize:14}}>＋</button>
            </div>
            <button onClick={()=>remove(item)} style={{background:"none",border:"none",color:"#ef4444",cursor:"pointer",fontSize:13,opacity:0.5,flexShrink:0}}
              onMouseEnter={e=>e.currentTarget.style.opacity=1} onMouseLeave={e=>e.currentTarget.style.opacity=0.5}>🗑</button>
          </div>
        );
      })}
    </div>
  );
}
